import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

import './badge.scss';

type Props = {
  badgeClasses?: Argument;
  badgeInnerWrapperClasses?: Argument;
};

export const Badge: ReactFCC<Props> = ({
  badgeClasses,
  badgeInnerWrapperClasses,
  children,
}) => (
  <span className="-tw-mt-1">
    <span className={cs('bbk-badge', badgeClasses)}>
      <div className={cs('bbk-badge-inner-wrapper', badgeInnerWrapperClasses)}>
        {children}
      </div>
    </span>
  </span>
);
